module.exports = __webpack_public_path__ + "img/other.3cdbd595.jpg";